export default {
  setCompaniesData(state, companies) {
    state.companies = companies;
  },
  setCurrentCompany(state, company) {
    state.currentCompany = company;
  }
}
